import T from 'components/T';
import { M, colors } from '@dashboard-experience/mastodon';
import React from 'react';
import styled from 'styled-components';

interface DescribeFieldProps {
  selectedField: (selected: string) => void;
  /**
   * Canonical `reason_*` token sent as `disputed_items[].reason`; the backend
   * matches these against fixed English values, so it must never be localized.
   */
  value: string;
  caption: string;
}

const CardStyled = styled(M.Card)`
  cursor: pointer;
  padding: 1.5rem !important;

  &:hover {
    background-color: #f4f4f4 !important;
    border: 1px solid #bbb !important;
    color: ${colors.checkrBlueHover} !important;
  }
`;

const DescribeField = ({
  caption,
  value,
  selectedField = () => {},
}: DescribeFieldProps) => {
  return (
    <CardStyled
      onClick={() => {
        selectedField(value);
      }}
      role='button'
      tabIndex={0}
      data-testid='candidate-select-reason-btn'
    >
      <T value={caption} dangerousHTML />
    </CardStyled>
  );
};

export default DescribeField;
